import React from 'react'
import { Grid } from '@mui/material'

import { FormikField, HelperBlock, ReactSelect, countriesOptions } from 'shared'

import { useFormikContext } from 'formik'
import { ProfileFormValues } from '../config'

import { useProfileForm } from 'utils/providers/ProfileFormProvider'
import useAddress from 'utils/hooks/useAddress'

const ProfileFormAddress = () => {
  const { setFieldValue, values, errors, setErrors } = useFormikContext<
    ProfileFormValues & { address: { state: string } }
  >()
  const { onCountryChange } = useProfileForm()
  const { addressField, statesOptions } = useAddress(values.address)

  return (
    <Grid container spacing={2}>
      <Grid item md={12}>
        <HelperBlock
          label="You must reside in the United States or United Kingdom
            to participate in our program."
        />
      </Grid>
      <Grid item md={12} xs={12}>
        <ReactSelect
          name="address.country"
          menuPlacement="top"
          options={countriesOptions}
          value={countriesOptions.find(
            (el) => el.value === values.address?.country
          )}
          label="Country"
          placeholder="Select a country"
          margin="none"
          onChange={(e) => {
            onCountryChange(e?.value || '')
            setFieldValue('address.country', e?.value || '')
            setErrors({
              ...errors,
              address: undefined,
            })
          }}
          error={errors?.address?.country || ''}
        />
      </Grid>
      {addressField.address ? (
        <Grid item md={12} xs={12}>
          <FormikField
            name="address.address"
            label={addressField.address.label}
            placeholder={addressField.address.placeholder}
          />
        </Grid>
      ) : null}
      {addressField.address2 ? (
        <Grid item md={12} xs={12}>
          <FormikField
            name="address.address2"
            label={addressField.address2.label}
            placeholder={addressField.address2.placeholder}
          />
        </Grid>
      ) : null}
      {addressField.city ? (
        <Grid item md={6} xs={12}>
          <FormikField
            name="address.city"
            label={addressField.city.label}
            placeholder={addressField.city.placeholder}
          />
        </Grid>
      ) : null}
      {addressField.state ? (
        <Grid item md={6} xs={12}>
          <ReactSelect
            name="address.state"
            menuPlacement="top"
            options={statesOptions}
            value={statesOptions.find(
              (el) => el.value === values.address?.state
            )}
            label={addressField.state.label}
            placeholder={addressField.state.placeholder}
            margin="none"
            onChange={(e) => setFieldValue('address.state', e?.value || '')}
            error={errors?.address?.state || ''}
          />
        </Grid>
      ) : null}
      {addressField.postalCode ? (
        <Grid item md={6} xs={12}>
          <FormikField
            name="address.postalCode"
            label={addressField.postalCode.label}
            placeholder={addressField.postalCode.placeholder}
          />
        </Grid>
      ) : null}
    </Grid>
  )
}

export default ProfileFormAddress
